import React, { useState } from "react";
import "./Contact.css";
import ContactHero from "../../Components/ContactHero/ContactHero";
import ContactTopics from "../../Components/ContactTopics/ContactTopics";
import ContactForm from "../../Components/ContactForm/ContactForm";
import ContactReassurance from "../../Components/ContactReassurance/ContactReassurance";
import ContactDetails from "../../Components/ContactDetails/ContactDetails";

/** Allowed landing-page topics only; unknown URL parameters are ignored. */
const INITIAL_TOPICS = Object.freeze({
  "openlift-demo": "demo",
  "iss-devis": "devis",
  partenariat: "partenariat",
  autre: "autre",
});

function getInitialSubject() {
  if (typeof window === "undefined") return "";
  const objet = new URLSearchParams(window.location.search).get("objet");
  return Object.prototype.hasOwnProperty.call(INITIAL_TOPICS, objet)
    ? INITIAL_TOPICS[objet]
    : "";
}

export default function Contact() {
  const [selectedSubject, setSelectedSubject] = useState(getInitialSubject);

  return (
    <section className="contact" aria-labelledby="contact-title">
      <div className="contact-bg" aria-hidden="true" />

      <ContactHero />
      <ContactTopics selectedSubject={selectedSubject} onSubjectChange={setSelectedSubject} />

      <div className="contact-outer">
        {/* Grille : formulaire, réassurance et coordonnées professionnelles */}
        <div className="contact-grid">
          {/* Sections 03 + 04 : formulaire existant et réassurance, même colonne. */}
          <div className="contact-main">
            <ContactForm
              selectedSubject={selectedSubject}
              onSubjectChange={setSelectedSubject}
            />
            <ContactReassurance />
          </div>

          {/* Section 05 — Coordonnées vérifiables, sans carte embarquée. */}
          <ContactDetails />
        </div>
      </div>
    </section>
  );
}
